const {Component} = require("react");
const PropTypes = require("prop-types");

class InclusiveCheckbox extends Component {

	static get propTypes() {
		return {
			label: PropTypes.string,
			name: PropTypes.string,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.number
			]),
			checked: PropTypes.bool,
			handleChange: PropTypes.func
		};
	}

	constructor(props) {
		super(props);
		this.state = {
			checked: props.checked === true
		};
	}

	componentWillReceiveProps(props) {
		this.setState({checked: props.checked});
	}

	get className() {
		let classList = ["checkbox-field"];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	onChange = (e) => {
		this.setState({checked: e.target.checked}, () => {
			if (typeof this.props.handleChange === "function") {
				this.props.handleChange(this.props.value, this.state.checked);
			}
		});
	};

	renderInput() {
		return this.state.checked ? (
			<input type="hidden" name={this.props.name} value={this.props.value}/>
		) : null;
	}

	render() {
		return (
			<label className={this.className}>
				{this.renderInput()}
				<input type="checkbox" checked={this.state.checked} onChange={this.onChange}/>
				{this.props.label}
			</label>
		);
	}

}

module.exports = InclusiveCheckbox;



// WEBPACK FOOTER //
// ./resources/js/components/forms/InclusiveCheckbox.js